import {
    GITCARD_DISPLAYAREAS_LOADING, GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS,
    GET_GITCARD_DISPLAYAREAS_DATA_ERROR, RESET_GITCARD_DISPLAYAREAS
} from "../actions/actionGiftCardDisplayAreas";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "GiftCardDisplayAreaNos";

const initialState = {
    giftcardsdisplayAreas: [],
    giftcarddisplayArea: loadState(sessionKey, {}),
    loading: false,
    giftcardsdisplayAreasError: ''
};

function reducerGiftCardDisplayAreas(state = initialState, action) {
    switch (action.type) {
        case GITCARD_DISPLAYAREAS_LOADING: {
            return {
                ...state,
                loading: true,
                giftcardsdisplayAreasError: ''
            };
        }

        case GET_GITCARD_DISPLAYAREAS_DATA_SUCCESS: {

            let newObj = {};

            if (action.id !== null && action.id !== undefined) {
                let newDisplayAreas = JSON.parse(JSON.stringify(action.payload));
                newObj = { ...newDisplayAreas.filter(x => x.DisplayAreaNo == action.id)[0] };

                saveState(sessionKey, newObj);
            }

            return {
                ...state,
                loading: false,
                giftcardsdisplayAreas: action.payload,
                giftcarddisplayArea: newObj,
                giftcardsdisplayAreasError: ''
            };
        }

        case GET_GITCARD_DISPLAYAREAS_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                giftcardsdisplayAreas: action.payload,
                giftcardsdisplayAreasError: action.error
            }
        }
        case RESET_GITCARD_DISPLAYAREAS: {

            saveState(sessionKey, {});

            return {
                ...state,
                loading: false,
                giftcarddisplayArea: {},
                giftcardsdisplayAreas: [],
                giftcardsdisplayAreasError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerGiftCardDisplayAreas;